import { Link } from "react-router-dom";
import {
  QrCodeIcon,
  PencilSquareIcon,
  TrashIcon,
} from "@heroicons/react/24/outline";
import { getUser } from "../utils/storage";

export default function ActionButtons({
  id,
  onDelete,
  viewLabel = "View",
  editLabel = "Edit",
  deleteLabel = "Delete",
}) {
  const viewUrl = `/devices/${id}/details`;
  const editUrl = `/devices/form/${id}/edit`;
  const user = getUser();
  return (
    <div className="flex items-center pl-4">
      <a
        href={viewUrl}
        className="cursor-pointer bg-blue-50 p-1 border-blue-400 border-[1px] rounded-md hover:bg-blue-100 mr-2"
        title={viewLabel}
      >
        <QrCodeIcon
          className="h-5 w-5 flex-shrink-0 text-blue-400"
          aria-hidden="true"
        />
      </a>
      <Link
        to={editUrl}
        className="text-indigo-600 cursor-pointer bg-indigo-50 border-indigo-400 hover:bg-indigo-100 mr-2 border-[1px] rounded-md p-1"
        title={editLabel}
      >
        <PencilSquareIcon
          className="h-5 w-5 flex-shrink-0 text-indigo-400"
          aria-hidden="true"
        />
      </Link>
      {onDelete && (user.role === "SuperAdmin" || user.role === "Admin") && (
        <button
          onClick={onDelete}
          className="text-red-500 cursor-pointer bg-red-50 border-red-400 hover:bg-red-100 border-[1px] rounded-md p-1"
          title={deleteLabel}
        >
          <TrashIcon
            className="h-5 w-5 flex-shrink-0 text-red-400"
            aria-hidden="true"
          />
        </button>
      )}
    </div>
  );
}
